import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  p: 1.5,
};

export const content: SxStyle = {
  pt: 0,
};
